import { Component, OnInit } from "@angular/core";
import { ViewCell } from "ng2-smart-table";
import { CustomEntityUtils } from './../../custom-entity-utils.service';

@Component({
  template: `
<span> {{ value.name }}</span>

  `,
  styles: [`


  `
  ]


})
export class AttributeJoinViewcellComponent implements ViewCell, OnInit {
  value: string | number | any;


  constructor(private customEntityUtils: CustomEntityUtils){

  }
  rowData: any;
  visible: boolean;
  element: String;
  ngOnInit() {

    console.log("Init")
  }

}
